import React, { useEffect, useState } from 'react';
import {Translate, useTranslation} from '../../../../config/TranslationProvider';
import {useAppConfiguration} from '../../../../AppConfiguration';
import ListingActionButton from '../../../partials/ListingActionButton';
import classNames from 'classnames';
import LocationsFilter from '../../../filter/LocationsFilter';
import BackDrop from '../../../partials/BackDrop';
import { useWindowWidth } from '../../../../helper';
import config from '../../../../config/config';

const LocationsListingHeader = ({totalCount, listType, setListType, tags, onSubmit, filter, fixedFilter}) => {
    const [showFilter, setShowFilter] = useState(false);
    const [showBackDrop, setShowBackDrop] = useState(false);
    const {breakpoints} = config;

    const {listingTitle} = useAppConfiguration();

    const [size] = useWindowWidth();
    useEffect(() => {
        if (size < breakpoints.sm && listType === 'grid') {
            setListType('list');
        }
    }, [size, listType, setListType, breakpoints]);

    const closeFilterDropdown = () => {
        setShowFilter(false);
        setShowBackDrop(false);
    };

    const filterForm = (
        <div>
            <LocationsFilter
                tags={tags}
                onSubmit={onSubmit}
                filter={filter}
                fixedFilter={fixedFilter}
            />
            <button onClick={closeFilterDropdown} className="close-filter-dropdown">
                <i className="la la-times" />
            </button>
            {showBackDrop && <BackDrop click={closeFilterDropdown} breakpoints="backdrop-for-xs" />}
        </div>
    );

    return (
        <div className="atbd_generic_header">

            {/* Left side */}
            {/* Locations Filter */}
            <div className="filter-dropdown">
                <div className={classNames({
                    dropdown: true,
                    show: showFilter,
                })}>
                    <button
                        id="filterDropdown"
                        type="button"
                        className="open_filter_btn"
                        aria-haspopup="true"
                        aria-expanded={showFilter}
                        aria-label={useTranslation('filter_open_close')}
                        onClick={e => {
                            e.target.blur();

                            setShowFilter((prevState) => !prevState);
                            setShowBackDrop((prevState) => !prevState);
                        }}
                    >
                        <span className="la la-filter la-2x" />
                    </button>
                    <div aria-labelledby="filterDropdown" className={classNames({
                        'dropdown-menu': true,
                        'locations-dropdown-menu': true,
                        show: showFilter,
                    })}>
                        {filterForm}
                    </div>
                </div>
            </div>
            <div>
                <h2>
                    {listingTitle.locations ? listingTitle.locations : <Translate value="all_locations" />}
                </h2>
                <p><Translate value="results" /> {totalCount}</p>
            </div>

            {/* Right side */}
            <div className="atbd_listing_action_btn btn-toolbar" role="toolbar">
                {/* List button */}
                <ListingActionButton btnType="list" listType={listType} setListType={setListType} />
                {/* Grid button */}
                <ListingActionButton btnType="grid" listType={listType} setListType={setListType} />
                {/* Map Button */}
                <ListingActionButton btnType="map" listType={listType} setListType={setListType} />
            </div>

        </div>
    );
};

export default LocationsListingHeader;
